<div class="modal-header">
  <h4 class="modal-title pull-left">{{ isEdit ? 'Edit Client User': 'New Client User' }}</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <page-client-user-edit
    [edit]="isEdit"
    [isLender]="isLender"
    [manage]="manageFlag"
    [isOther]="isOther"
    [clientUser]="clientUser"
    (onCreate)="onConfirm($event)"
    (onCancel)="onCancel()">
  </page-client-user-edit>
</div>
